import { ForwardedRef, forwardRef, useEffect, useState } from "react";
import * as s from "../SignupStyled";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import {
  FreeTrialInfo,
  ResellerUserInfo,
  SIGNUP_UPDATE_TYPE,
  SignupUserInfo,
  ValueType,
} from "api/interfaces/authInterface.interface";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";
import PasswordInput from "components/atoms/input/PasswordInput";
import PasswordBubble from "components/blocks/bubble/PasswordBubble";
import { checkPasswordNumberRegEx, checkPasswordRegEx } from "utils/regEx";

interface Props {
  validateInputMsg: ValidateMsg;
  onChangeUserInfo: (type: SIGNUP_UPDATE_TYPE, data: string | boolean) => void;
  userInfo: SignupUserInfo | ResellerUserInfo | FreeTrialInfo;
  label: string;
  tabIndex: number;
  fieldKey: string;
  type: SIGNUP_UPDATE_TYPE;
  showRules?: boolean;
  onEnter?: () => void;
}

function Password(props: Props, ref?: ForwardedRef<HTMLInputElement>) {
  const {
    validateInputMsg,
    onChangeUserInfo,
    userInfo,
    label,
    tabIndex,
    fieldKey,
    type,
    showRules = true,
    onEnter,
  } = props;
  const [isFocus, setIsFocus] = useState<boolean>(false);
  useEffect(() => {
    const value = userInfo[
      fieldKey as ValueType
    ] as string;
    if (
      !(value.length < 8) &&
      checkPasswordRegEx(value) &&
      checkPasswordNumberRegEx(value)
    ) {
      let timer = setTimeout(() => {
        setIsFocus(false);
      }, 800);
      return () => {
        clearTimeout(timer);
      };
    } else {
      //setIsFocus(true);
    }
  }, [userInfo[fieldKey as ValueType]]);
  return (
    <>
      <ModalInput
        label={label}
        noBold
        essential
        isValidated={!!validateInputMsg[fieldKey]}
        validatedWord={validateInputMsg[fieldKey]}
      >
        <s.PasswordInputInner>
          <PasswordInput
            ref={ref}
            className="input-field"
            placeholder={`Please enter your ${label.toLowerCase()}`}
            onEnter={() => onEnter?.()}
            value={userInfo[fieldKey as ValueType] as string}
            onChange={(e) => onChangeUserInfo(type, e.target.value)}
            isValidated={!!validateInputMsg[fieldKey]}
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
            tabIndex={tabIndex}
            data-testid="auth-signup-common-password-input-change-user-info"
          />

          {isFocus && showRules && (
            <s.PasswordBubble>
              <PasswordBubble
                password={userInfo[fieldKey as ValueType] as string}
              />
            </s.PasswordBubble>
          )}
        </s.PasswordInputInner>
      </ModalInput>
    </>
  );
}

export default forwardRef(Password);
